export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7948.93c8e8d6.jpg";